import styled from 'styled-components';

export const StyledJsonTextarea = styled.textarea<{ $hasError: boolean }>`
  width: 100%;
  font-family: monospace;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  resize: vertical;
  box-sizing: border-box;
  ${({ $hasError, theme }) => ($hasError ? `border-color: ${theme.colors.dangerText};` : '')}
`;

export const StyledFieldsetCard = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: ${({ theme }) => theme.radii.sm};
  padding: 0.5rem;
  background: var(--gray-100);
`;

export const StyledSchemaDescription = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: 0.5rem;
  line-height: 1.4;
`;

export const StyledFieldLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 2px;
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

export const StyledTypeBadge = styled.span`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 10.5px;
  font-weight: 400;
`;

export const StyledFieldRow = styled.div`
  margin-bottom: 6px;
`;

export const StyledBooleanLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

export const StyledFullWidthInput = styled.input`
  width: 100%;
`;

export const StyledJsonValueTextarea = styled.textarea`
  width: 100%;
  font-family: monospace;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  resize: vertical;
  box-sizing: border-box;
`;

export const StyledFieldError = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.colors.dangerText};
  margin-top: 2px;
`;
